import React, { Component } from 'react'
import './NavbarStyle.css'
import Image from '../Images/SinhgadLogo2.png'
import Image2 from '../Images/5259008.png'
import { Link, useNavigate } from 'react-router-dom'
import { onAuthStateChanged, signOut } from "firebase/auth";
import { firebaseAuth } from './Firebase'

export default class Navbar extends Component {
  constructor(props){
    super(props);
    this.state = {
      selectedTab: window.sessionStorage.getItem('selectedTab'),
      Nav:false,
      User:null,
    }
  }

  componentDidMount(){
    onAuthStateChanged(firebaseAuth, (user) => {
      if(user){
        const number = user.phoneNumber;
        this.setState({
            User : number
        })
      }
    });          
  }

  onTabChange = (index) => {
    window.sessionStorage.setItem('selectedTab', JSON.stringify(index))
    let data = window.sessionStorage.getItem('selectedTab')
    this.setState({
      selectedTab : data
    })
  }

  onChangeNav =()=>{
    this.setState({
      Nav:!this.state.Nav
    })
  }

  handleVoteRedirect=()=>{
    onAuthStateChanged(firebaseAuth, (user) => {
      if(user){
        this.onTabChange(5);
        this.props.navigate('/Voting')
      }else{
        alert('Please Login to view this page')
      }
    });
  }

  handleDashRedirect=()=>{
    onAuthStateChanged(firebaseAuth, (user) => {
      if(user){
        this.onTabChange(5);
        this.props.navigate('/Dashboard')
      }else{
        alert('Please Login to view this page')
      }
    });
  }

  handleSignout=()=>{
    signOut(firebaseAuth).then(() => {
        console.log('Sign-out successful')
        alert('Sign-out successful')
      }).catch((error) => {
        console.log(error)
      });
    window.sessionStorage.setItem('selectedTab', JSON.stringify(1));
    window.location.href='/';
  }

  render() {
    const {selectedTab} = this.state;
    const {Nav} =this.state;
    return (
      <>
    {window.innerWidth > 768 ?
      <div className='Navbar'>
        <div className='NavbarLogo'>
          <img src={Image} alt='Logo' width='120px' height='60px'></img>
        </div>

        <div className='NavbarText'>
          <ul>
            <li onClick={()=>{this.onTabChange(1)}}><Link className={selectedTab === null || selectedTab === '1' || selectedTab === '2' || selectedTab === '3' || selectedTab === '4' ? "activeL" : ""} to='/'>Home</Link></li>
            {selectedTab === null || selectedTab === '1' || selectedTab === '2' || selectedTab === '3' || selectedTab === '4' ? <li onClick={()=>{this.onTabChange(2)}}><a href="#About">About</a></li>:""}
            {selectedTab === null || selectedTab === '1' || selectedTab === '2' || selectedTab === '3' || selectedTab === '4' ? <li onClick={()=>{this.onTabChange(3)}}><a href="#Working">How it works</a></li>:""}
            {selectedTab === null || selectedTab === '1' || selectedTab === '2' || selectedTab === '3' || selectedTab === '4' ? <li onClick={()=>{this.onTabChange(4)}}><a href="#Features">Features</a></li>:""}
            <li >{this.state.User === '+918805307338' ?<Link className={selectedTab === '5' ? "activeL" : ""} onClick={()=>this.handleDashRedirect()}>Dasboard</Link>:<Link className={selectedTab === '5' ? "activeL" : ""} onClick={()=>this.handleVoteRedirect()}>Vote</Link>}</li>
            <li>{this.state.User === null?<Link className={selectedTab === '6' ? "activeL" : ""} to='/Login' onClick={()=>{this.onTabChange(6)}}>Login</Link>:<a href='/' onClick={(e)=>this.handleSignout(e)}>Logout</a>}</li>
          </ul>
        </div>
      </div> :<div>
      <div className='Navbar2'>
        <div className='NavbarLogo'>
          <Link onClick={()=>{this.onTabChange(1);this.onChangeNav()}} to='/'><img src={Image} alt='Logo' width='120px' height='60px'></img></Link>
        </div>
        <div>
        <img onClick={()=>this.onChangeNav()} className='NavButton' src={Image2} alt='buttonNav' width='30px' height='30px'></img>
        </div>
      </div>
      { Nav? <div className='NavbarText2'>
        <ul>
          {selectedTab === null || selectedTab === '1' || selectedTab === '2' || selectedTab === '3' || selectedTab === '4' ? <li onClick={()=>{this.onTabChange(2);this.onChangeNav()}}><a href="#About">About</a></li>:""}
          {selectedTab === null || selectedTab === '1' || selectedTab === '2' || selectedTab === '3' || selectedTab === '4' ? <li onClick={()=>{this.onTabChange(3);this.onChangeNav()}}><a href="#Working">How it works</a></li>:""}
          {selectedTab === null || selectedTab === '1' || selectedTab === '2' || selectedTab === '3' || selectedTab === '4' ? <li onClick={()=>{this.onTabChange(4);this.onChangeNav()}}><a href="#Features">Features</a></li>:""}
          <li>{this.state.User === '+918805307338' ?<Link onClick={()=>{this.handleDashRedirect();this.onChangeNav()}}>Dasboard</Link>:<Link onClick={()=>{this.handleVoteRedirect();this.onChangeNav()}}>Vote</Link>}</li>
          <li>{this.state.User === null?<Link onClick={()=>{this.onTabChange(6);this.onChangeNav()}} to='/Login'>Login</Link>:<a href='/' onClick={(e)=>this.handleSignout(e)}>Logout</a>}</li>
        </ul>
        </div> :
        <div></div>}
      </div>
    }
      </>
    )
  }
}
export function NavbarH (props){
  const navigate = useNavigate()
  return(<Navbar navigate={navigate}/>)
}